import { FaInstagram } from "react-icons/fa";

export default function InstagramFloating() {
  return (
    <a
      href="https://www.instagram.com/credibletechnologies?igsh=bDJ1Mmt6cDl0a2Fu"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 right-20 sm:bottom-6 sm:right-28 md:bottom-6 md:right-28 lg:bottom-6 lg:right-24 xl:bottom-6 xl:right-32 bg-pink-500 
      hover:bg-pink-600 text-white p-3 sm:p-4 rounded-full shadow-xl flex items-center justify-center z-50 animate-bounce transition-all"
    >
      <FaInstagram className="w-5 h-5 sm:w-6 sm:h-6 md:w-6 lg:w-6 xl:w-6" />
    </a>
  );
}
